<template>
  <div>
    <div class="banner">
      <div class="banner-box d-flex" >
        <div class="title-box">
          <div class="text-box">
          </div>
        </div>
        <div class="content-box container" style="width:50%; height:60vh; padding:5vh;">
          <div class="px-3 py-sm-5 row" style="height:100%; background:rgba(255, 255, 255, 0.9); text-align:left">
            <div class="col-12">
              <p>
                本區提供多益口說測驗 TOEIC Speaking Test & TOEIC Bridge Speaking Test 的豐富備考資源，涵蓋必考單字、題型演練、模擬練習等資源如下：
              </p>
              <ol class="col-12 align-self-center">
                <li>應考資訊：掌握考試流程、作答方式與評分標準，建立扎實的應考觀念。</li>
                <li>必考單字：熟背常考單字片語，有效提升字彙能力。</li>
                <li>模考與題型解析：擬真試題演練，搭配詳細解析，強化應試技巧與臨場表現。</li>
              </ol>
            </div>
            <div class="col-12 align-self-end" style="text-align:center">
              <button type="button" @click="goExam('toeic')" class="btn btn-danger btn-lg btn-sm mx-2 my-2" style="font-size:1rem">進入多益口說模擬考</button>
              <button type="button" @click="goExam('toeic_bridge')" class="btn btn-danger btn-lg btn-sm mx-2 my-2" style="font-size:1rem">進入多益Bridge口說模擬考</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rwd-show" style="text-align:center">
      <button type="button" @click="goExam('toeic')" class="btn btn-danger btn-lg btn-sm mx-2 my-2" style="font-size:1rem">多益模擬考</button>
      <button type="button" @click="goExam('toeic_bridge')" class="btn btn-danger btn-lg btn-sm mx-2 my-2" style="font-size:1rem">Bridge模擬考</button>
    </div>
    <div class="col-12 align-self-center my-4" style="text-align:center">
      <button type="button" @click="type='normal'" class="btn btn-outline-primary btn-lg btn-sm mx-2 my-2" :class="{'active': type==='normal'}" style="font-size: 1.25rem">TOEIC® Speaking Test 說明</button>
      <button type="button" @click="type='bridge'" class="btn btn-outline-primary btn-lg btn-sm mx-2 my-2" :class="{'active': type==='bridge'}"  style="font-size: 1.25rem">TOEIC® Bridge Speaking Test 說明</button>
    </div>
    <div v-if="type==='normal'" class="container">
      <div class="row">
        <div class="col">
          <div class="d-flex my-3" id="introduction">
            <h3 class="title pr-3">測驗簡介</h3>
            <div class="line"></div>
          </div>
          <div>
            <h4 class="font-border">什麼是TOEIC® Speaking Test</h4>
            <br/>
            在全球化的環境下，隨著國際商務交流日益頻繁，使用英語進行溝通的需求不斷提升。無論是電子郵件、面對面會談、簡報、電話聯繫，或是視訊會議，都需要具備流暢的英語口說與書寫能力，才能達成有效溝通。TOEIC® Speaking Test 採取線上施測方式，能全面評量考生在職場及日常情境中運用英語口說的能力。同時，其結果亦可作為企業於人才招募、績效評鑑與培訓過程中的重要依據，協助快速甄選符合國際需求的人才。
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="d-flex my-3" id="content">
            <h3 class="title pr-3">題型內容</h3>
            <div class="line"></div>
          </div>
          <div class="my-3">
            TOEIC® Speaking Test共11題，測驗時間約40分鐘（含基本資料及問卷填寫）。
            <h5 class="font-border my-2">口說測驗</h5>
            <img style="width:100%" src="../../assets/image/table/speaking/from_toeicTest_content01.svg" alt="">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="d-flex my-3" id="situation">
            <h3 class="title pr-3">測驗情境</h3>
            <div class="line"></div>
          </div>
          <div class="row my-3">
            <img style="width:100%" src="../../assets/image/table/speaking/from_toeicTest_content02.svg" alt="">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="d-flex my-3" id="guide">
            <h3 class="title pr-3">能力對照</h3>
            <div class="line"></div>
          </div>
          <div class="row my-3">
            <img style="width:100%" src="../../assets/image/table/speaking/from_toeicTest_content03.svg" alt="">
          </div>
        </div>
      </div>
    </div>
    <div v-else class="container">
      <div class="row">
        <div class="col">
          <div class="d-flex my-3" id="introduction">
            <h3 class="title pr-3">測驗簡介</h3>
            <div class="line"></div>
          </div>
          <div>
            <h4 class="font-border">什麼是TOEIC® Bridge Speaking Test</h4>
            <br/>
            為了滿足日常實用需求，並提供適合初級與中級程度學習者的英語溝通評量工具， ETS®特別推出了TOEIC® Bridge Speaking Test。TOEIC® Bridge Speaking Test採取線上施測方式，此測驗兼具全面性、實用性與高度信度，題材多元，聚焦於日常生活情境，並可與 TOEIC® 測驗 相互銜接。相較於 TOEIC®測驗，TOEIC® Bridge Speaking Test的題數較少、難度相對簡單，測驗時間更短，因此特別適合作為進階學習的橋樑。測驗成績亦能廣泛應用於人才招募、能力分級、英語課程前測與結業評量，以及學習進度追蹤等多種用途。
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="d-flex my-3" id="content">
            <h3 class="title pr-3">題型內容</h3>
            <div class="line"></div>
          </div>
          <div class="my-3">
            TOEIC® Speaking Test共8題，測驗時間約15分鐘（含基本資料及問卷填寫）。
            <h5 class="font-border my-2">口說測驗</h5>
            <img style="width:100%" src="../../assets/image/table/speaking/from_toeicBTest_content01.svg" alt="">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="d-flex my-3" id="situation">
            <h3 class="title pr-3">測驗情境</h3>
            <div class="line"></div>
          </div>
          <div class="row my-3">
            <img style="width:100%" src="../../assets/image/table/speaking/from_toeicBTest_content02.svg" alt="">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="d-flex my-3" id="guide">
            <h3 class="title pr-3">能力對照</h3>
            <div class="line"></div>
          </div>
          <div class="row my-3">
            <img style="width:100%" src="../../assets/image/table/speaking/from_toeicBTest_content03.svg" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../store/api'
export default {
  name: 'Topic-raiders',
  components: {

  },
  data () {
    return {
      exams: null,
      type: 'normal'
    }
  },
  computed: {
  },
  mounted () {
    this.getExamData()
    this.scrollTop()
  },
  methods: {
    async getExamData () {
      const { data } = await api.get('/contents/exams?page=1&pageSize=100&type=simulation')
      this.exams = data.data
    },
    goPage (id, viewId) {
      this.$router.push({ name: 'Examination', params: { examId: id ,viewId: viewId } })
    },
    goExam(type) {
      this.$router.push({ name: 'TOEIC_list', params: { exam_type: type } })
    },
    scrollTop () {
      const currentScroll = document.documentElement.scrollTop || document.body.scrollTop
      if (currentScroll > 0) {
        window.scrollTo(0, 0)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/styles/custom.scss";
  .banner {
    height: 60vh;
    background-image: url('../../assets/image/pic/banner_toeicTest_top.jpg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .title-box {
      width: 50%;
      .text-box {
        width: 50%;
        margin: auto;
        h4 {
          line-height: 200px;
          text-align: center;
          font-size: 150px;
          font-weight: 900;
          color: #fff;
          -webkit-text-stroke: 1.5px rgb(0, 0, 0);
        }
      }
    }
  }
  @media(max-width: 1080px){
    .banner {
      background-position: 10 10;
      .banner-box {
        display: none !important;
      }
    }
    .rwd-show {
      display: block !important;
    }
  }
  .container {
    text-align: left;
  }
  .anctors {
    button {
      min-width: 150px;
      font-size: 1.2rem;
    }
  }
  .title {
    font-size: 1.5rem;
    font-weight: 800;
    color: $main-color;
    background-color: $white-color;
    z-index: 10;
  }
  .font-border {
    font-weight: 600;
  }
  .line {
    width: 100%;
    position: absolute;
    // left: 100%;
    top: 32px;
    border-top: black 1px solid;
  }
  .rwd-show {
    display: none;
  }
  @media screen and (max-width: 380px) {
    .rwd-hide {
      display: none !important;
    }
    .rwd-show {
      display: block;
    }
    .banner {
      height: 30vh;
      background-size: contain;
      background-image: url('../../assets/image/pic/banner_toeicTest_top_S.jpg');
    }
  }
</style>
